import React from 'react';
import { Stack, Typography } from '@mui/material';
import FormattedText from './FormattedText';
import MessageActionButtons from './MessageActionButtons';
import MessageHeaderBlock from './MessageHeaderBlock';
import useMessageStyles from '../../../hooks/useMessageStyles';

export default function TemplateMessage({ message }) {
  const { messageFooterSx, messageTypeLabelSx, messageRichStackSx, messageTemplateHeaderTextSx } =
    useMessageStyles();
  const template = message.template || {};
  const buttons = template.buttons || message.buttons || [];
  const typeLabel = template.name ? `Template · ${template.name}` : 'Template';
  const hasStructuredHeader = Boolean(
    message.header?.url ||
    message.header?.text ||
    message.header?.fileName ||
    message.header?.kind === 'document' ||
    message.header?.kind === 'image' ||
    message.header?.kind === 'video'
  );
  const textHeaderFallback = !hasStructuredHeader && template.header ? template.header : null;

  const handleButtonClick = (button) => {
    const isUrl = button.type?.toUpperCase().includes('URL');
    if (isUrl && button.url) {
      window.open(button.url, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <Stack spacing={0} sx={messageRichStackSx}>
      <Typography component="span" sx={messageTypeLabelSx}>
        {typeLabel}
      </Typography>

      {hasStructuredHeader && <MessageHeaderBlock header={message.header} bleed />}

      {textHeaderFallback && (
        <FormattedText
          text={textHeaderFallback}
          variant="body2"
          sx={messageTemplateHeaderTextSx}
        />
      )}

      {(template.body || message.text) && (
        <FormattedText text={template.body || message.text} />
      )}

      {template.footer && (
        <Typography variant="caption" sx={messageFooterSx}>
          {template.footer}
        </Typography>
      )}

      <MessageActionButtons buttons={buttons} onButtonClick={handleButtonClick} />
    </Stack>
  );
}
